import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScriptComponent } from './script.component';

@NgModule({
  declarations: [
    ScriptComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ScriptComponent
  ]
})
export class ScriptLoaderModule {}
